exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=\"checkbox\"]{\ncursor: pointer;\n-webkit-appearance: none;\n-moz-appearance: none;\n     appearance: none;\nbackground: #EF3054;\nborder-radius: 10px;\nbox-sizing: border-box;\nposition: relative;\nbox-sizing: content-box ;\nwidth: 20px;\nheight: 20px;\nborder-width: 0;\ntransition: all .3s linear;\nvertical-align: middle;\n}\ninput[type=\"checkbox\"]:checked{\n  background-color: #2ECC71;\n}\ninput[type=\"checkbox\"]:focus{\n  outline: 0 none;\n  box-shadow: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/baba_frontend/src/app/users/users.component.css
// module id = ../../../../../src/app/users/users.component.css
// module chunks = main